module.exports = __webpack_public_path__ + "static/media/iPhone14-1.2c195765.png";